import React, { memo } from 'react';
import { Segment } from 'semantic-ui-react';
import { groupBy } from '../../utils/array';
import { Investment as InvestmentComponent } from './Investment/';


var Line = function () { return React.createElement("div", { className: 'line' }); };
var Investments = memo(function (_a) {
    var investments = _a.investments, onInvestmentClick = _a.onInvestmentClick, productIdSelected = _a.productIdSelected, className = _a.className, investmentTransactionsLoading = _a.investmentTransactionsLoading;
    var groupedInvestments = groupBy(investments, 'type');
    var investmentTypes = Object.keys(groupedInvestments);
    return (React.createElement(Segment, { className: "Investments pluggy " + (className || '') }, investmentTypes.map(function (id, index) {
        var _a;
        return (React.createElement("div", { key: id },
            React.createElement(InvestmentComponent, { investments: groupedInvestments[id] || [], onClick: onInvestmentClick, isSelected: (_a = groupedInvestments[id]) === null || _a === void 0 ? void 0 : _a.some(function (investment) { return investment.id === productIdSelected; }), investmentTransactionsLoading: investmentTransactionsLoading }),
            index !== investmentTypes.length - 1 && React.createElement(Line, null)));
    })));
});
export { Investments };
